import React, { useEffect, useState, useRef } from 'react'
import { useGoogleMaps } from '../Hooks'
import { translate } from '../Services/translation'

const GoogleReview = (props) => {
    // STATE
    const [reviews, setReviews] = useState(null)
    const [open, setOpen] = useState(false)

    // REFS
    const ref = useRef()
    const reviewRef = useRef()

    // HOOKS
    const maps = useGoogleMaps()

    useEffect(() => {
        if (maps && ref.current && !reviews) {
            const location = new maps.LatLng(props.lat, props.long)

            const service = new maps.places.PlacesService(
                new maps.Map(ref.current)
            )
            service.nearbySearch(
                {
                    location,
                    keyword: 'Däckskiftarna',
                    radius: 1400,
                },
                (result, status) => {
                    if (
                        status == maps.places.PlacesServiceStatus.OK &&
                        result?.length > 0
                    ) {
                        const placeId = result[0].place_id

                        service.getDetails(
                            {
                                placeId,
                                fields: [
                                    'rating',
                                    'reviews',
                                    'user_ratings_total',
                                ],
                            },
                            (result, status) => {
                                if (
                                    status == maps.places.PlacesServiceStatus.OK
                                ) {
                                    setReviews({
                                        rating: result.rating,
                                        reviews: result.reviews,
                                        reviewTotal: result.user_ratings_total,
                                    })
                                }
                            }
                        )
                    }
                }
            )
        }
    }, [maps, ref, reviews, setReviews])

    // Event listener for closing review modal when clicking outside
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (
                open &&
                reviewRef.current &&
                !reviewRef.current.contains(e.target)
            ) {
                setOpen(false)
            }
        }

        document.addEventListener('click', handleClickOutside)

        return () => {
            document.removeEventListener('click', handleClickOutside)
        }
    }, [open, reviewRef])

    // Reusable elements
    const getStar = (rating) => {
        if (rating >= 0.29 && rating <= 0.71) {
            return <i className="fa fa-star-half-o" aria-hidden="true"></i>
        } else if (rating > 0.71) {
            return <i className="fa fa-star" aria-hidden="true"></i>
        } else {
            return <i className="fa fa-star-o" aria-hidden="true"></i>
        }
    }

    const getRating = (rating) => {
        return (
            <span className="review__stars">
                {getStar(rating)}
                {getStar(rating - 1)}
                {getStar(rating - 2)}
                {getStar(rating - 3)}
                {getStar(rating - 4)}
            </span>
        )
    }

    return (
        <>
            <div ref={ref} style={{ display: 'none' }}></div>
            {reviews && (
                <div className="review__container">
                    <button
                        onClick={() => setOpen(true)}
                        className="review__container--button"
                    >
                        <span className="review__container--button--rating">
                            {reviews.rating}
                        </span>
                        {getRating(reviews.rating)}
                        {reviews?.reviewTotal && (
                            <span className="review__container--button--count">{`${
                                reviews.reviewTotal
                            } ${
                                reviews.reviewTotal > 1
                                    ? translate('stationpage.reviews')
                                    : translate('stationpage.review')
                            }`}</span>
                        )}
                    </button>
                    {reviews.reviews?.length > 0 && open && (
                        <div className="review__container--reviews">
                            <div
                                ref={reviewRef}
                                className="review__container--reviews--container"
                            >
                                <div className="review__container--reviews--container--top-bar">
                                    <h3>{translate('stationpage.reviews')}</h3>
                                    <button onClick={() => setOpen(false)}>
                                        <span></span>
                                        <span></span>
                                    </button>
                                </div>
                                {reviews.reviews.map((item, index) => (
                                    <div key={`review-${index}`}>
                                        <div>
                                            <h5>{item.author_name}</h5>
                                            <span>
                                                {` ${item.relative_time_description}`}
                                            </span>
                                        </div>
                                        {getRating(item.rating)}
                                        <p>{item.text}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            )}
        </>
    )
}

export default GoogleReview
